<template>
    <div class="error-msg-wrap">
        <div v-if="loaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <div>
                <div style="font-weight:bold;margin-bottom:15px">Select a role from a role sheet the standard user for this employee has access to. Check department and location settings if a role sheet is not showing here.</div>
                <select v-model="sheetInput" @change="setColOptions(null)">
                    <option :value="null">Select Sheet</option>
                    <option v-for="(s, i) in allSheets" :value="s" :key="i">{{ s.Name }}</option>
                </select>

                <select v-if="inputCols.length" v-model="sheetColInput">
                    <option v-for="(c, i) in inputCols" :value="c.id" :key="i">{{ c.text }}</option>
                </select>

                <input style="margin-top:15px" :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import { readRoleSheet, seatLabel } from '@/roleSheet';

export default defineComponent({
    name: 'EditEmployeeRole',
    props: [ 'employeeToEdit' ],
    components: {
        
    },
    data() {
        return {
            disableButton: false,
            allSheets: [] as any,
            sheetInput: null as any,
            sheetColInput: null as any,
            inputCols: [] as any,
            loaded: false,
        }
    },
    async created() {
        while(!this.$store.state.allNodesLoaded) {
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        this.allSheets = [];

        await axios.get(`${this.$store.state.apiUrl}/api/playbook/nodesforpublicuser?employeeID=${this.employeeToEdit.ID}&type=SHEET`)
            .then(resp => {
                this.allSheets = resp.data;
            })
            .catch(e => {
                alert(e?.response?.data || 'There was an error');
                console.log(e);
                this.$emit('close');
            })

        if(this.employeeToEdit.RoleSheetSlug && this.employeeToEdit.RoleSheetColID) {
            this.sheetInput = this.allSheets.find((s: any) => {
                return s.Slug == this.employeeToEdit.RoleSheetSlug;
            })
            if(this.sheetInput) {
                this.setColOptions(this.employeeToEdit.RoleSheetColID);
            }
        }

        this.loaded = true;
    },
    methods: {
        async submit() {
            let data = {
                employeeID: this.employeeToEdit.ID,
                sheetSlug: null,
                sheetCol: null
            }
            if(this.sheetInput && this.sheetColInput) {
                data = {
                    employeeID: this.employeeToEdit.ID,
                    sheetSlug: this.sheetInput.Slug,
                    sheetCol: this.sheetColInput
                }
            }

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/employees/role`, data)
                .then(resp => {
                    this.$emit('close');
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            this.disableButton = false;
        },
        setColOptions(initCol: any) {
            this.inputCols = [];
            this.sheetColInput = null;
            if(!this.sheetInput) {
                return;
            }
            this.inputCols = readRoleSheet(this.sheetInput).seats.map((seat: any, i: number) => ({
                id: seat.id,
                text: seatLabel(seat) || 'Seat ' + (i + 1)
            }));
            if(initCol) {
                this.sheetColInput = initCol;
            } else {
                this.sheetColInput = this.inputCols.length ? this.inputCols[0].id : null;
            }
        }
    }
});
</script>
